//src/pages/ConfiguracoesValorPonto.js

import React, { useEffect, useState } from "react";
import axios from "../axiosConfig";
import ModalSemPermissao from "../components/ModalSemPermissao";
import { CheckCircle2, Coins, Save, Settings } from "lucide-react";

import "./ConfiguracoesValorPonto.css";

function ConfiguracoesValorPonto() {
  const [valorPonto, setValorPonto] = useState("");
  const [salvo, setSalvo] = useState(false);
  const [erro, setErro] = useState("");
  const [resumo, setResumo] = useState(null);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    async function fetchValor() {
      try {
        const res = await axios.get("/configuracoes/valor-ponto");
        setValorPonto(res.data.valor?.toString() || "0.03");
      } catch (err) {
        console.error("Erro ao buscar valor do ponto:", err);
        setErro("Erro ao carregar o valor atual do ponto.");
      }
    }

    fetchValor();
  }, []);

  const salvarValor = async () => {
    const valorNumerico = parseFloat(valorPonto);

    setErro("");
    setSalvo(false);
    setResumo(null);

    if (!valorNumerico || isNaN(valorNumerico) || valorNumerico <= 0) {
      setErro("Informe um valor numérico maior que zero para o ponto.");
      return;
    }

    setSalvando(true);

    try {
      const res = await axios.put("/configuracoes/valor-ponto", {
        valor: valorNumerico,
      });

      setResumo(res.data);
      setSalvo(true);

      setTimeout(() => {
        setSalvo(false);
        setResumo(null);
      }, 5000);
    } catch (err) {
      console.error("Erro ao salvar valor do ponto:", err);
      setErro("Erro ao salvar o valor do ponto.");
    } finally {
      setSalvando(false);
    }
  };

  const usuario = JSON.parse(localStorage.getItem("usuario"));

  const podeAlterarValor =
    usuario?.tipo === "admin" &&
    usuario?.permissoes?.some(
      (p) =>
        p.rota === "configuracoes-valor-ponto" &&
        p.pode_editar
    );

  if (!podeAlterarValor) {
    return <ModalSemPermissao onClose={() => (window.location.href = "/")} />;
  }

  return (
    <div className="valorPontoAdmin-page">
      <div className="valorPontoAdmin-topbar">
        <div>
          <span className="valorPontoAdmin-kicker">Configurações</span>
          <h2>Valor do Ponto</h2>
          <p>
            Defina o valor em reais usado para calcular a conversão dos prêmios
            em pontos no catálogo.
          </p>
        </div>
      </div>

      {erro && <div className="valorPontoAdmin-alert danger">{erro}</div>}

      {salvo && resumo && (
        <div className="valorPontoAdmin-alert success">
          <CheckCircle2 size={16} />
          Valor salvo com sucesso. Prêmios atualizados:{" "}
          <strong>{resumo.premios_atualizados}</strong>
        </div>
      )}

      <section className="valorPontoAdmin-card">
        <div className="valorPontoAdmin-cardHeader">
          <div>
            <h3>Configuração de conversão</h3>
            <span>Informe quanto vale 1 ponto em reais.</span>
          </div>

          <Settings size={18} />
        </div>

        <div className="valorPontoAdmin-content">
          <div className="valorPontoAdmin-infoBox">
            <Coins size={22} />
            <div>
              <strong>Impacto no catálogo</strong>
              <span>
                Ao salvar, o sistema pode recalcular os prêmios vinculados ao
                valor do ponto.
              </span>
            </div>
          </div>

          <div className="valorPontoAdmin-field">
            <label htmlFor="valorPonto">Valor em R$ de 1 ponto</label>
            <input
              id="valorPonto"
              type="number"
              step="0.001"
              min="0.001"
              value={valorPonto}
              onChange={(e) => setValorPonto(e.target.value)}
              placeholder="Ex: 0.03"
            />
          </div>

          <div className="valorPontoAdmin-actions">
            <button
              type="button"
              className="valorPontoAdmin-btn primary"
              onClick={salvarValor}
              disabled={salvando}
            >
              <Save size={16} />
              {salvando ? "Salvando..." : "Salvar valor"}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ConfiguracoesValorPonto;